//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    newDesign: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoaded: false,
    };
  },
  methods: {
    iframeOnLoad() {
      this.isLoaded = true;
    },
  },
};
